var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text",attrs:{"color":_vm.buttonColor,"depressed":"","disabled":_vm.disabled,"block":_vm.block,"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('ok')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }